<script>
  import IconButton from '@smui/icon-button';
  import { navigate } from 'svelte-routing';
  import Menu from '@smui/menu';
  import List, { Item, Separator, Text } from '@smui/list';

  export let disabled = false;

  let sessionMenu;
</script>

<div>
  <IconButton
    id="add-session-button"
    title="Add Session"
    class="material-icons gigxr-icon-button add-session-button"
    on:click={() => navigate('/sessions/create-session-select-app')}
    {disabled}
  >
    add_box
  </IconButton>

</div>

<style>
  :global(.add-session-button:disabled) {
    opacity: 0.38;
  }
</style>
